module.exports = __webpack_public_path__ + "static/media/logo117.4902c64d.png";